<script>
import Button from '@components/Button'
import ImageLoader from '@components/ImageLoader'
import GridLoader from '@components/GridLoader'
import Dialog from '@components/Dialog'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Cursos',
  components: {
    Button,
    ImageLoader,
    Dialog,
    GridLoader
  },
  data: () => ({
    loading: false,
    hasMore: false,
    currentPage: 0
  }),
  computed: {
    ...mapState(['detail', 'cursos', 'totalCursos']),
    scale () {
      return {
        xs: 0.5,
        sm: 0.6,
        md: 0.8,
        lg: 1,
        xl: 1
      }[this.rl.breakpoint]
    },
    style () {
      return {
        '--margin-horizontal': this.rl.margin,
        '--gutter': this.rl.gutter,
        '--scale': this.scale
      }
    }
  },
  created () {
    this.handleVerMais(false)
  },
  methods: {
    ...mapActions(['getCursos', 'getDetail']),
    handleVerMais (cumulative) {
      this.loading = true
      const lines = 3
      const regPag = { xs: 2, sm: 4, md: 4, lg: 4, xl: 8 }[this.rl.breakpoint] * lines
      this.getCursos({ regPag, numPag: this.currentPage, cumulative }).then(response => {
        if (response.length) {
          this.currentPage++
          this.hasMore = true
        } else {
          this.hasMore = false
        }
      }).finally(() => {
        this.loading = false
      })
    },
    abrirDetalheCurso (id) {
      this.getDetail(id).then(() => {
        this.$refs.dialogDetalheCurso.open()
        this.$refs['iframe-video'].src = this.cursos.find(curso => curso.id === id).video
      })
    },
    assinar () {
      this.$refs.dialogAssinatura.open()
    }
  }
}
</script>
<template>
  <div
    class="cursos"
    :style="style"
  >
    <h1
      class="view-cursos-title"
      v-html="wl.strings['view-cursos-title']"
    />
    <p
      class="view-cursos-content"
      v-html="wl.strings['view-cursos-content']"
    />
    <GridLoader
      :columns="{xs: 2, sm: 4, md: 4, lg: 4, xl: 8}[rl.breakpoint]"
      :margin="rl.margin"
      :gutter="rl.gutter"
      :aspect-ratio="2.44048"
      :loading="loading"
      :has-more="hasMore"
      @verMaisClick="() => handleVerMais(true)"
    >
      <ImageLoader
        v-for="curso in cursos"
        :key="curso.id"
        :url="curso.imagemVertical"
        @click="() => abrirDetalheCurso(curso.id)"
      />
    </GridLoader>
    <Button
      size="lg"
      class="btn-assine-agora"
      :color="wl.colors.secondary"
      :text-color="wl.colors.on.secondary"
      :text="wl.strings['btn-assine-agora']"
      style="margin: 30px auto 15px"
      :scale="scale"
      @click="() => { assinar() }"
    />
    <Dialog
      ref="dialogDetalheCurso"
      :fullscreen="rl.smAndDown"
      @close="() => $refs['iframe-video'].src = ''"
    >
      <template v-slot:title>
        {{ detail ? detail.titulo : '' }}
      </template>
      <template v-slot:text>
        <iframe
          ref="iframe-video"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen=""
          width="100%"
          height="254px"
          :title="detail ? detail.titulo : ''"
        />
        <div
          class="gostou-do-conteudo"
          style="font-weight: 600"
          v-html="wl.strings['gostou-do-conteudo']"
        />
        <Button
          :size="'md'"
          class="btn-assine-agora"
          :color="wl.colors.primary"
          :text-color="wl.colors.on.primary"
          :text="wl.strings['btn-assine-agora']"
          style="margin: 30px auto 15px"
          :scale="scale"
          @click="() => { assinar() }"
        />
      </template>
    </Dialog>
    <Dialog
      ref="dialogAssinatura"
      fullscreen
      dense
    >
      <template v-slot:text>
        <iframe
          width="100%"
          height="100%"
          :src="wl.urls.assinatura"
          style="border:none; height: calc(100vh - 55px);"
        />
      </template>
    </Dialog>
  </div>
</template>

<style lang="scss" scoped>
.view-cursos-title {
  font: bold calc(40px * var(--scale))/calc(55px * var(--scale)) 'Open Sans';
  text-align: center;
  margin-left: var(--margin-horizontal);
  margin-right: var(--margin-horizontal);
  text-transform: uppercase;
}

.view-cursos-content {
  font: normal calc(24px * var(--scale))/calc(32px * var(--scale)) 'Open Sans';
  text-align: center;
  margin-left: var(--margin-horizontal);
  margin-right: var(--margin-horizontal);
}
</style>
